import { z } from "zod";

export const uploadResultsSchema = z.object({
	uploadResults: z
		.array(
			z.object({
				id: z.string(),
				path: z.string(),
				fullPath: z.string(),
				directory: z.string(),
				contentType: z.string(),
				pathPrefix: z.string(),
				size: z.number(),
			}),
		)
		.or(z.null()),
});

export type UploadResultsSchema = z.infer<typeof uploadResultsSchema>;
